import { render } from "./SendOrderSuccessModal.vue?vue&type=template&id=834ad094&scoped=true"
import script from "./SendOrderSuccessModal.vue?vue&type=script&lang=js"
export * from "./SendOrderSuccessModal.vue?vue&type=script&lang=js"

import "./SendOrderSuccessModal.vue?vue&type=style&index=0&id=834ad094&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834ad094"]])

export default __exports__